module.exports = __webpack_public_path__ + "img/soundsys_white_big.resized.c52dc3f4.png";